<template>
    <modal v-if="message" class="message-modal">
        <modal-body>
            <section class="form-elegant">
                <row>
                    <column>
                        <card-body>
                            <div v-show="success" class="alert alert-success fade show" role="alert">
                                {{ alertMessage }}
                            </div>
                            <div class="text-center">
                                <h4 class="font-weight-bold text-uppercase"><strong>{{$t('leave_us_a')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('message')}}</strong></h4>
                            </div>
                            <form @submit.prevent="validateUser">
                                <md-field :class="getValidationClass('email')">
                                    <md-icon>email</md-icon>
                                    <label>{{$t('your_email')}}</label>
                                    <md-input type="email" v-model="form.email" md-dense :disabled="sending"></md-input>
                                    <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
                                </md-field>
                                <md-field :class="getValidationClass('fullname')">
                                    <md-icon>account_box</md-icon>
                                    <label>{{$t('your_complete_name')}}</label>
                                    <md-input type="text" v-model="form.fullname" md-dense :disabled="sending"></md-input>
                                    <span class="md-error" v-if="!$v.form.fullname.required">{{$t('required.fullname')}}</span>
                                    <span class="md-error" v-else-if="!$v.form.fullname.minlength">{{$t('invalid.fullname')}}</span>
                                </md-field>
                                <md-field :class="getValidationClass('subject')">
                                    <md-icon>subject</md-icon>
                                    <label>{{$t('subject')}}</label>
                                    <md-input type="text" v-model="form.subject" md-dense :disabled="sending"></md-input>
                                    <span class="md-error" v-if="!$v.form.subject.required">{{$t('required.subject')}}</span>
                                </md-field>
                                <md-field :class="getValidationClass('message')">
                                    <label>{{$t('message')}}</label>
                                    <md-textarea v-model="form.message" md-dense :disabled="sending"></md-textarea>
                                    <md-icon>message</md-icon>
                                    <span class="md-error" v-if="!$v.form.message.required">{{$t('required.message')}}</span>
                                </md-field>
                                <div class="text-center mt-3">
                                  <vue-recaptcha @verify="markRecaptchaAsVerified"
                                      sitekey="6LcqL1waAAAAAHqYYjCXntjHyWQn6XLmENFYN7tF">
                                  </vue-recaptcha>
                                  <span class="blabel-alert">{{contactForm.pleaseTickRecaptchaMessage}}</span><br>
                                </div>
                                <div class="text-center mt-3">
                                    <btn :disabled="sending" color="info" size="md" class="btn-rounded">{{$t('send_message')}}<i class="fa fa-paper-plane-o ml-2"></i></btn>
                                </div>
                            </form>
                        </card-body>
                    </column>
                </row>
            </section>
        </modal-body>
        <modal-footer class="p-2">
            <btn size="sm" outline="info" darkWaves @click.native="closeModal">{{$t('close')}}</btn>
        </modal-footer>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
    </modal>
</template>

<script>
import { Btn, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Container, Row, Column, Card, CardBody } from 'mdbvue';
import VueRecaptcha from 'vue-recaptcha';
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BASE_API } from '../helpers/base'

export default {
  name: 'MessageModal',
  props: ['message'],
  mixins: [validationMixin],
  data(){
    return {
        form: {
            email: null,
            fullname: null,
            subject: null,
            message: null
        },
        contactForm: {
          recaptchaVerified: false,
          pleaseTickRecaptchaMessage: ''
        },
        userSaved: false,
        sending: false,
        lastUser: null,
        success: false,
        alertMessage: null
    }
  },
  components: {
    Btn, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Row, Column, Container, Card, CardBody, VueRecaptcha
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      fullname: {
        required,
        minLength: minLength(3)
      },
      subject: {
        required
      },
      message: {
        required
      }
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.email = null
      this.form.fullname = null
      this.form.subject = null
      this.form.message = null
    },
    sendMessage () {
        if (!this.contactForm.recaptchaVerified) {
          this.contactForm.pleaseTickRecaptchaMessage = 'Veuillez cocher recaptcha.';

          return;
        }
        this.sending = true
        this.success = false

        let data = {
            email: this.form.email,
            fullname: this.form.fullname,
            subject: this.form.subject,
            message: this.form.message
        }

        axios.post(`${BASE_API}/send_message`, data).then(response => {
            this.sending = false
            this.success = true
            this.alertMessage = this.$t('message_sent_successfully')
            this.clearForm()
            this.setTimeOut()
            console.log(response.data);
        }).catch(error => {
            console.log(error);
        });
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.sendMessage()
      }
    },
    closeModal(){
      this.$emit('closeModal');
      this.clearForm();
    },
    setTimeOut(){
      window.setTimeout(function(){
        $('.alert').fadeIn(function(){
            setTimeout(function(){
                $(".alert").fadeOut(500, function(){
                    $(this).hide();
                });
            }, 4000)
        })
      });
    },
    markRecaptchaAsVerified(response) {
      this.contactForm.pleaseTickRecaptchaMessage = '';
      this.contactForm.recaptchaVerified = true;
    }
  }
};
</script>

<style scoped>
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
.blabel-alert {
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageModal.vue